export class NewLocationBankingData{
    constructor(
        public bankName: String = '',
        public branchName: String = '',
        public AccountNumber: number = null,
        public locationGroups: Array<any> = new Array<any>() 
    ){}
}